/**
 * Checks if an element is an `HTMLElement`.
 *
 * @param {any} element the target object
 * @returns {boolean} the query result
 */
const isHTMLElement = (element) => typeof element === 'object' && element instanceof HTMLElement;
export default isHTMLElement;



//////////////////
// WEBPACK FOOTER
// ./node_modules/shorter-js/src/misc/isHTMLElement.js
// module id = 20
// module chunks = 0